import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/viec-can-xem")({
  component: () => <Outlet />,
});
